module.exports = __webpack_public_path__ + "media/Dolphin.e9a3b333.mp3";